import PostList from '../../components/post/post-list';

const PostSatisfied = () => {
  return (
    <div className="container">
      <PostList endpoint="/post/get-satisfied-posts/" />
    </div>
  );
};

export default PostSatisfied;